<template>
  <SectionTemplate
    title="好莱坞级3D数字人真实细节一眼惊艳"
    sub-title="高质量超写实3D形象"
    desc="无需摄影棚，也能轻松呈现电影质感。有言数千款好莱坞级3D数字人，
    涵盖多年龄、多族裔、多风格，材质细腻、发丝清晰、妆造服饰皆精致自然，出场即惊艳"
    class="amazing-detail-page"
  >
    <div class="video-container rounded-[12px] overflow-hidden">
      <VideoPlayer
        :poster="getFeUrl('/youyan-platform/character-intro/amazing-detail/detail.png')"
        :url="getFeUrl('/youyan-platform/character-intro/amazing-detail/output.m3u8')"
        ref="videoRef"
        :class="`w-full h-full video_cover`"
        :autoplay="true"
        :loop="false"
        :enable-fullscreen="false"
        :muted="isMuted"
        :controls="true"
      />
    </div>
    <StartBtn class="amazing-detail-btn" type="small" />
  </SectionTemplate>
</template>

<script setup lang="ts">
import VideoPlayer from '~/components/video-player/index.vue';
import SectionTemplate from '~/design/widgets/landing-section/cn-template.vue';
import { getFeUrl } from '~/utils/url';
import StartBtn from '../../components/start-btn.vue';
const isMuted = inject<boolean>('isMuted') || true;
</script>

<style lang="scss" scoped src="./mobile.scss"></style>
<style lang="scss" src="./pc.scss" scoped />
